import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Users2 } from "lucide-react";
import api from "@/lib/apiClient";
import { EmptyState } from "@/components/dashboard/primitives";
import { Skeleton } from "@/components/ui/skeleton";

export default function EventAttendees() {
  const { event } = useOutletContext();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/events/${event.id}/attendees`).then(({ data }) => setData(data)).catch(() => setData({ count: 0, items: [] }));
  }, [event.id]);

  if (!data) return <Skeleton className="h-64 rounded-xl" />;

  return (
    <div>
      <div className="rounded-xl border border-border bg-card p-5 mb-4 flex items-center gap-4">
        <span className="h-11 w-11 rounded-lg bg-accent/10 flex items-center justify-center"><Users2 className="h-5 w-5 text-accent" /></span>
        <div><p className="font-display text-2xl font-bold text-foreground leading-none">{data.count}</p><p className="text-xs text-muted-foreground mt-1">Total attendees joined</p></div>
      </div>

      {data.count === 0 ? (
        <EmptyState icon={Users2} title="No attendees yet" description="Attendees appear here as they scan the QR code and join the event." />
      ) : (
        <div className="rounded-xl border border-border bg-card divide-y divide-border" data-testid="attendees-list">
          {data.items.slice(0, 100).map((a) => (
            <div key={a.id} className="flex items-center justify-between p-3.5">
              <span className="text-sm text-foreground">{a.name || "Anonymous attendee"}</span>
              <span className="text-xs text-muted-foreground">{a.joined_at ? new Date(a.joined_at).toLocaleString() : ""}</span>
            </div>
          ))}
          {data.count > 100 && <div className="p-3 text-center text-xs text-muted-foreground">+ {data.count - 100} more</div>}
        </div>
      )}
    </div>
  );
}
